export const PROJECT_LIST_ITEM_ACTIONS = {
  click: 'click',
  delete: 'delete',
  rename: 'rename',
};
